var React = require('react');

function IconMusicInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-3.93 -336.177)"},React.createElement("path",{"d":"M13.5 342.75v22.282A6 6 0 1 0 9 375a6 6 0 0 0 6-6v-16.664l22.5-5.625v12.321A6 6 0 1 0 33 369a6 6 0 0 0 6-6v-26.25a.75.75 0 0 0-.932-.728l-24 6a.75.75 0 0 0-.568.728ZM9 373.5a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Zm24-6a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Zm4.5-22.336v-7.453L15 343.336v7.453l22.5-5.625Z","style":{"fill":"#00a2ee"},"transform":"translate(.93 .177)"})));
}

IconMusicInline.defaultProps = {"viewBox":"0 0 36 39","width":"36","height":"39","xmlSpace":"preserve","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"}};

module.exports = IconMusicInline;

IconMusicInline.default = IconMusicInline;
